import { FC, useContext, useRef } from 'react';

import { Button } from '@smartshell/ui-kit';

import { useUploadFile } from 'hooks';
import { LocalizationContext } from 'localization';
import notification from 'services/notificationService';

import s from './AdvertisementItem.module.scss';
import { IAdvertisementItemProps } from './interfaces';

export const AdvertisementItem: FC<IAdvertisementItemProps> = ({
  value,
  onDelete,
  onReplace,
}) => {
  const { t } = useContext(LocalizationContext);
  const inputRef = useRef<HTMLInputElement>(null);
  const IMAGE_PROXY_BASE = process.env.REACT_APP_IMAGE_PROXY_BASE;

  const { uploadImage } = useUploadFile();

  return (
    <div className={s.frame}>
      <div className={s.image_controls}>
        <Button
          className={s.delete_button}
          onClick={onDelete}
          iconName="BucketIcon"
          onlyIcon
          color="red"
          variant="ghost"
        ></Button>
      </div>
      <div className={s.container}>
        <div
          className={s.image_container}
          style={{
            backgroundImage: `url(${IMAGE_PROXY_BASE}/rs:fit:160:160/g:sm/plain/${value})`,
          }}
        >
          <div
            className={s.image}
            style={{
              backgroundImage: `url(${IMAGE_PROXY_BASE}/rs:fit:160:160/g:sm/plain/${value})`,
            }}
          >
            <input
              ref={inputRef}
              type="file"
              accept=".png,.jpg,.jpeg"
              hidden
              onChange={async (e) => {
                const file = e.target.files?.[0];
                e.target.value = '';

                if (!file) return;

                try {
                  const newUrl = await uploadImage(file);
                  onReplace(newUrl);
                } catch (error) {
                  notification.info({
                    t,
                    type: 'error',
                    title: t('upload.file.error'),
                    message: String(error),
                  });
                }
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
